import Vue from 'vue'
import VueRouter from 'vue-router'

//Route
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser, getUserPermission } from '@/auth/utils'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Dashboard',
        breadcrumb: [
          {
            text: 'Dashboard',
            active: true,
          },
        ],
      },
    },
    {
      path: '/view-user',
      name: 'view-user',
      component: () => import('@/views/pages/users/List.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'User Panel',
        breadcrumb: [
          {
            text: 'User Information',
            active: true,
          },
        ],
      },
    },
    {
      path: '/add-user',
      name: 'add-user',
      component: () => import('@/views/pages/users/Add.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'User From',
        breadcrumb: [
          {
            text: 'Add User',
            active: true,
          },
        ],
      },
    },
    {
      path: '/edit-user/:userId',
      name: 'edit-user',
      component: () => import('@/views/pages/users/Edit.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'User From',
        breadcrumb: [
          {
            text: 'Edit User',
            active: true,
          },
        ],
      },
    },
    {
      path: '/permission-user/:userId',
      name: 'permission-user',
      component: () => import('@/views/pages/users/Permission.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Permission From',
        breadcrumb: [
          {
            text: 'Permission User',
            active: true,
          },
        ],
      },
    },
    {
      path: '/view-category',
      name: 'view-category',
      component: () => import('@/views/pages/categories/List.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Category List',
        breadcrumb: [
          {
            text: 'Category List',
            active: true,
          },
        ],
      },
    },
    {
      path: '/add-category',
      name: 'add-category',
      component: () => import('@/views/pages/categories/Add.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Add Category',
        breadcrumb: [
          {
            text: 'Add Category',
            active: true,
          },
        ],
      },
    },
    {
      path: '/edit-category/:categoryID',
      name: 'edit-category',
      component: () => import('@/views/pages/categories/Edit.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Category From',
        breadcrumb: [
          {
            text: 'Edit category',
            active: true,
          },
        ],
      },
    },
    {
      path: '/view-subscriber',
      name: 'view-subscriber',
      component: () => import('@/views/pages/subscribers/List.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Subscriber List',
        breadcrumb: [
          {
            text: 'Subscriber List',
            active: true,
          },
        ],
      },
    },
    {
      path: '/subscriber-details/:subscriberID',
      name: 'subscriber-details',
      component: () => import('@/views/pages/subscribers/View.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Subscriber Details',
        breadcrumb: [
          { text: 'Subscribers', to: '/view-subscriber' },
          { text: 'Details', active: true },
        ],
      },
    },
    {
      path: '/add-subscriber',
      name: 'add-subscriber',
      component: () => import('@/views/pages/subscribers/Add.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Add Subscriber',
        breadcrumb: [
          {
            text: 'Add Subscriber',
            active: true,
          },
        ],
      },
    },
    {
      path: '/quote-subscriber/:subscriberID',
      name: 'quote-subscriber',
      component: () => import('@/views/pages/subscribers/Quote.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Subscriber Quotes',
        breadcrumb: [
          {
            text: 'Quote List',
            active: true,
          },
        ],
      },
    },
    {
      path: '/quote-details/:quoteID',
      name: 'quote-details',
      component: () => import('@/views/pages/subscribers/QuoteDetails.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Subscriber Quote Details',
        breadcrumb: [
          {
            text: 'Quote Details',
            active: true,
          },
        ],
      },
    },
    {
      path: '/quote-invoice/:quoteID',
      name: 'quote-invoice',
      component: () => import('@/views/pages/subscribers/QuoteInvoice.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Subscriber Quote Invoice',
        breadcrumb: [
          {
            text: 'Quote Invoice',
            active: true,
          },
        ],
      },
    },
    {
      path: '/edit-subscriber/:subscriberID',
      name: 'edit-subscriber',
      component: () => import('@/views/pages/subscribers/Edit.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Subscriber From',
        breadcrumb: [
          {
            text: 'Edit subscriber',
            active: true,
          },
        ],
      },
    },
    {
      path: '/view-catalogue',
      name: 'view-catalogue',
      component: () => import('@/views/pages/catalogues/List.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Catalogue List',
        breadcrumb: [
          {
            text: 'Catalogue List',
            active: true,
          }
        ],
      },
    },
    {
      path: '/add-catalogue',
      name: 'add-catalogue',
      component: () => import('@/views/pages/catalogues/Add.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Add catalogue',
        breadcrumb: [
          {
            text: 'Add catalogue',
            active: true,
          }
        ],
      },
    },
    {
      path: '/edit-catalogue/:catalogueID',
      name: 'edit-catalogue',
      component: () => import('@/views/pages/catalogues/Edit.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Edit catalogue',
        breadcrumb: [
          {
            text: 'Edit catalogue',
            active: true,
          }
        ],
      },
    },
    {
      path: '/view-catalogue/:catalogueID',
      name: 'view-catalogue',
      component: () => import('@/views/pages/catalogues/View.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'View catalogue',
        breadcrumb: [
          {
            text: 'View catalogue',
            active: true,
          }
        ],
      },
    },
    {
      path: '/category-details/:id',
      name: 'category-details',
      component: () => import('@/views/pages/catalogues/Detail.vue'),
      meta: {
        pageTitle: 'Catalogue Detail',
        breadcrumb: [
          {
            text: 'Catalogue Detail',
            active: true,
          },
        ],
      },
    },
    {
      path: '/view-draft',
      name: 'view-draft',
      component: () => import('@/views/pages/catalogues/Draft.vue'),
      meta: {
        pageTitle: 'Draft Panel',
        breadcrumb: [
          {
            text: 'Draft Panel',
            active: true,
          },
        ],
      },
    },
    {
      path: '/search-catalogue',
      name: 'view-search-catalogue',
      component: () => import('@/views/pages/catalogues/Search.vue'),
      meta: {
        pageTitle: 'Search Catalogue',
        breadcrumb: [
          {
            text: 'Search Catalogue',
            active: true,
          },
        ],
      },
    },
    {
      path: '/view-calculator',
      name: 'view-calculator',
      component: () => import('@/views/pages/calculator/Calculator.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'View calculator',
        breadcrumb: [
          {
            text: 'View calculator',
            active: true,
          },
        ],
      },
    },
    {
      path: '/quote-today',
      name: 'quote-today',
      component: () => import('@/views/pages/quote/today.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Today quotes',
        breadcrumb: [
          {
            text: 'Today quote',
            active: true,
          },
        ],
      },
    },
    {
      path: '/view-audit-log',
      name: 'view-audit-log',
      component: () => import('@/views/pages/audit/View.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Audit Log',
        breadcrumb: [
          {
            text: 'Audit Log',
            active: true,
          },
        ],
      },
    },
    {
      path: '/notifications',
      name: 'view-notification',
      component: () => import('@/views/pages/notification/List.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Notifications',
        breadcrumb: [
          {
            text: 'Notifications',
            active: true,
          },
        ],
      },
    },
    {
      path: '/send-push-notification',
      name: 'send-push-notification',
      component: () => import('@/views/pages/notification/Send.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Send Push Notification',
        breadcrumb: [
          {
            text: 'Send Push Notification',
            active: true,
          },
        ],
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/pages/profile/Profile.vue'),
      meta: {
        pageTitle: 'Profile',
        breadcrumb: [
          {
            text: 'Profile',
            active: true,
          },
        ],
      },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/pages/settings/Settings.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Settings',
        breadcrumb: [
          {
            text: 'Settings',
            active: true,
          },
        ],
      },
    },
    {
      path: '/logs',
      name: 'logs',
      component: () => import('@/views/pages/logs/Logs.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'System Logs',
        breadcrumb: [
          {
            text: 'System Logs',
            active: true,
          },
        ],
      },
    },
    {
      path: '/contact',
      name: 'view-contact',
      component: () => import('@/views/pages/contact/Inbox.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Contact Us',
        breadcrumb: [
          {
            text: 'Inbox',
            active: true,
          },
        ],
      },
    },
    {
      path: '/contact/:threadId',
      name: 'view-contact-thread',
      component: () => import('@/views/pages/contact/Thread.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Contact Us',
        breadcrumb: [
          {
            text: 'Inbox',
            to: { name: 'view-contact' },
          },
          {
            text: 'Conversation',
            active: true,
          },
        ],
      },
    },
    {
      path: '/view-subscription-plans',
      name: 'view-subscription-plans',
      component: () => import('@/views/pages/subscription-plans/List.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Subscription Plans',
        breadcrumb: [
          {
            text: 'Subscription Plans',
            active: true,
          },
        ],
      },
    },
    {
      path: '/add-subscription-plan',
      name: 'add-subscription-plan',
      component: () => import('@/views/pages/subscription-plans/Add.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Add Subscription Plan',
        breadcrumb: [
          {
            text: 'Add Subscription Plan',
            active: true,
          },
        ],
      },
    },
    {
      path: '/edit-subscription-plan/:planId',
      name: 'edit-subscription-plan',
      component: () => import('@/views/pages/subscription-plans/Edit.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Edit Subscription Plan',
        breadcrumb: [
          {
            text: 'Edit Subscription Plan',
            active: true,
          },
        ],
      },
    },
    {
      path: '/view-subscription-plan/:planId',
      name: 'view-subscription-plan',
      component: () => import('@/views/pages/subscription-plans/View.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'View Subscription Plan',
        breadcrumb: [
          {
            text: 'View Subscription Plan',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reports/subscription',
      name: 'subscription-reports',
      component: () => import('@/views/pages/reports/SubscriptionReports.vue'),
      beforeEnter: requiredAuth,
      meta: {
        pageTitle: 'Subscription Reports',
        breadcrumb: [
          {
            text: 'Reports',
          },
          {
            text: 'Subscription Reports',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'auth-login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/not-authorized',
      name: 'misc-not-authorized',
      component: () => import('@/views/pages/miscellaneous/NotAuthorized.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})
function requiredAuth(to, from, next){
  const userData = getUserData()
  const userPermission = getUserPermission()
    if (userData.is_admin == 1) {
       return next();
    } else {
      for (let i = 0; i < userPermission.length; i++) {
          //console.log(userPermission[i], to.name)
          if (userPermission[i] === to.name) {
              return next()
          }
      }
    }
    return next({ name: 'misc-not-authorized' })
}
router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  // Redirect if logged in
  if (isLoggedIn) {
    //const userData = getUserData()
    return next();
  }
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })
    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }
  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
